/* NOVALISE STUDIO — Client-side enhancements bundle
 * 1) Wishlist sin login (localStorage)
 * 2) Empty cart editorializado
 * 3) Size guide modal + model fit info (PDP only)
 */
(function () {
  'use strict';
  const KEY = 'nv_wishlist';

  // ========================================
  // WISHLIST
  // ========================================
  function read() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(x => typeof x === 'string' && x.length > 0);
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, 200))); } catch (e) {}
  }
  function toggle(handle) {
    if (!handle) return false;
    const list = read();
    const idx = list.indexOf(handle);
    if (idx >= 0) { list.splice(idx, 1); write(list); return false; }
    list.unshift(handle); write(list); return true;
  }
  function has(handle) { return read().indexOf(handle) >= 0; }

  const ICON_OUTLINE = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  const ICON_FILLED  = '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  function buildButton(handle) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nv-wishlist-btn';
    btn.setAttribute('data-nv-wishlist-toggle', '');
    btn.setAttribute('data-handle', handle);
    btn.setAttribute('aria-label', 'Guardar en lista de deseos');
    btn.innerHTML = has(handle) ? ICON_FILLED : ICON_OUTLINE;
    if (has(handle)) btn.classList.add('is-active');
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      const saved = toggle(handle);
      btn.innerHTML = saved ? ICON_FILLED : ICON_OUTLINE;
      btn.classList.toggle('is-active', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      updateCounts();
    });
    return btn;
  }
  function extractHandle(card) {
    const explicit = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    if (explicit) return explicit;
    const link = card.querySelector('a[href*="/products/"]');
    if (link) {
      const m = link.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i);
      if (m) return m[1];
    }
    return null;
  }
  function injectIntoCards() {
    const selectors = ['.product-card', '.card-product', '[data-product-card]', '.product-grid-item', '.collection-product-card', 'product-card', '.card--product'];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(card => {
        if (card.querySelector('.nv-wishlist-btn')) return;
        const handle = extractHandle(card);
        if (!handle) return;
        if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
        card.appendChild(buildButton(handle));
      });
    });
  }
  function updateCounts() {
    const n = read().length;
    document.querySelectorAll('[data-nv-wishlist-count]').forEach(el => {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }
  async function fetchProduct(handle) {
    try {
      const r = await fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } });
      if (!r.ok) return null;
      return await r.json();
    } catch (e) { return null; }
  }
  function formatMoney(cents) {
    try {
      const n = (cents || 0) / 100;
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(n);
    } catch (e) { return (cents / 100).toFixed(2) + ' EUR'; }
  }
  function renderProductCard(p) {
    if (!p) return '';
    const img = p.featured_image || (p.images && p.images[0]) || '';
    const url = p.url || ('/products/' + p.handle);
    const title = p.title || '';
    const price = formatMoney(p.price);
    return (
      '<article class="nv-wl-card" data-handle="' + p.handle + '">' +
        '<a class="nv-wl-card__img-link" href="' + url + '">' +
          (img ? '<img class="nv-wl-card__img" src="' + img + '" alt="' + title.replace(/"/g,'&quot;') + '" loading="lazy">' : '<div class="nv-wl-card__img--ph"></div>') +
        '</a>' +
        '<button type="button" class="nv-wl-card__remove" data-nv-wishlist-remove data-handle="' + p.handle + '" aria-label="Eliminar de la lista">×</button>' +
        '<a class="nv-wl-card__title" href="' + url + '">' + title + '</a>' +
        '<div class="nv-wl-card__price">' + price + '</div>' +
      '</article>'
    );
  }
  async function renderWishlistGrid() {
    const root = document.querySelector('[data-nv-wishlist-grid]');
    if (!root) return;
    const list = read();
    if (list.length === 0) {
      root.innerHTML = '<div class="nv-wl-empty"><h3>Tu lista de deseos está vacía</h3><p>Guarda tus prendas favoritas tocando el corazón en cualquier producto. Vuelven a aparecer aquí cuando estés lista para comprarlas.</p><a class="nv-wl-empty__cta" href="/collections/novedades">Descubrir Novedades</a></div>';
      return;
    }
    root.innerHTML = '<div class="nv-wl-grid nv-wl-grid--loading">Cargando tu selección…</div>';
    const products = await Promise.all(list.map(fetchProduct));
    const valid = products.filter(Boolean);
    if (valid.length === 0) {
      root.innerHTML = '<div class="nv-wl-empty"><h3>No pudimos cargar tus productos guardados</h3><p>Algunos productos pueden haber sido retirados.</p><a class="nv-wl-empty__cta" href="/collections/novedades">Ver Novedades</a></div>';
      return;
    }
    root.innerHTML = '<div class="nv-wl-grid">' + valid.map(renderProductCard).join('') + '</div>';
    root.querySelectorAll('[data-nv-wishlist-remove]').forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(btn.getAttribute('data-handle'));
        updateCounts();
        renderWishlistGrid();
      });
    });
  }

  // ========================================
  // EMPTY CART EDITORIAL
  // ========================================
  const EMPTY_CART_HTML = (
    '<div class="nv-cart-empty-editorial" data-nv-empty="1">' +
      '<div class="nv-cart-empty-editorial__eyebrow">Tu cesta</div>' +
      '<h3 class="nv-cart-empty-editorial__title">Tu cesta está vacía</h3>' +
      '<p class="nv-cart-empty-editorial__sub">Empieza por las piezas que están marcando esta temporada. Selección curada por NOVALISE.</p>' +
      '<div class="nv-cart-empty-editorial__ctas">' +
        '<a class="nv-cart-empty-editorial__cta nv-cart-empty-editorial__cta--primary" href="/collections/novedades">Ver Novedades</a>' +
        '<a class="nv-cart-empty-editorial__cta nv-cart-empty-editorial__cta--ghost" href="/collections/vestidos">Vestidos · Resort 26</a>' +
      '</div>' +
      '<div class="nv-cart-empty-editorial__trust">' +
        '<span>✓ Envío gratuito</span>' +
        '<span>✓ 30 días devolución</span>' +
        '<span>✓ Bizum · Apple Pay</span>' +
      '</div>' +
    '</div>'
  );
  // Single canonical selector for our injected block (marker attr + legacy class).
  const NV_EMPTY_SEL = '.nv-cart-empty-editorial, [data-nv-empty]';
  // Flag set while WE mutate the DOM, so the MutationObserver ignores its own work.
  let nvInjectingEmpty = false;

  function isCartDrawerEmpty(drawer) {
    if (!drawer) return false;
    // POSITIVE signal first: a real Horizon line-item row / qty input / item link.
    // Horizon uses `.cart-items__table-row` (note: contains "cart-items"), so any
    // selector that excludes "cart-items" matches nothing and wrongly reports empty.
    if (drawer.querySelector('.cart-items__table-row, .cart-item, [data-cart-item], cart-line-item, input[name="updates[]"], input[name^="updates["]')) return false;
    // Cart bubble count > 0 => items present even if row markup changed.
    const bubble = drawer.querySelector('[data-testid="cart-bubble"], .cart-bubble__text-count, [ref="cartBubbleCount"], .cart-count');
    if (bubble) {
      const n = parseInt((bubble.textContent || '').replace(/\D+/g, ''), 10);
      if (n > 0) return false;
    }
    // No rows and no positive count: genuinely empty.
    return true;
  }
  // Remove every extra copy of our block, keeping at most one (the first) within scope.
  function dedupeEmptyBlocks(scope) {
    const all = (scope || document).querySelectorAll(NV_EMPTY_SEL);
    for (let i = 1; i < all.length; i++) {
      if (all[i] && all[i].parentNode) all[i].parentNode.removeChild(all[i]);
    }
    return all.length ? all[0] : null;
  }
  function injectEmptyCart() {
    const drawers = document.querySelectorAll('cart-drawer-component, [class*="cart-drawer"]');
    if (!drawers.length) return;

    // Determine if ANY matched drawer is actually empty.
    let anyEmpty = false;
    drawers.forEach(drawer => { if (isCartDrawerEmpty(drawer)) anyEmpty = true; });

    nvInjectingEmpty = true;
    try {
      if (!anyEmpty) {
        // Cart has items: remove ALL of our injected blocks, restore native empty states.
        document.querySelectorAll(NV_EMPTY_SEL).forEach(el => { if (el.parentNode) el.parentNode.removeChild(el); });
        return;
      }

      // Cart is empty. STRONG idempotency guard: exactly ONE block must exist
      // anywhere in the document. If one already exists, dedupe extras and stop.
      const existing = document.querySelectorAll(NV_EMPTY_SEL);
      if (existing.length >= 1) {
        dedupeEmptyBlocks(document);
        return;
      }

      // None present yet: inject into the FIRST empty drawer only.
      let target = null;
      drawers.forEach(drawer => { if (!target && isCartDrawerEmpty(drawer)) target = drawer; });
      if (!target) return;

      const body = target.querySelector('[class*="cart-drawer__body"], [class*="cart-drawer__content"], [class*="cart-items"], main, [class*="empty"]') || target;
      target.querySelectorAll('[class*="empty"]:not(.nv-cart-empty-editorial):not([data-nv-empty])').forEach(el => { el.style.display = 'none'; });
      const wrap = document.createElement('div');
      wrap.innerHTML = EMPTY_CART_HTML;
      body.appendChild(wrap.firstElementChild);
      // Final safety dedupe in case a concurrent run also injected.
      dedupeEmptyBlocks(document);
    } finally {
      nvInjectingEmpty = false;
    }
  }

  // ========================================
  // SIZE GUIDE + MODEL FIT (PDP only)
  // ========================================
  // Per-product, type-accurate detection: fetch /products/{handle}.js once,
  // detect category from product_type + tags + title (authoritative),
  // fall back to legacy H1 heuristic if the fetch fails.
  var _nvProd = null;
  function nvProductInfo() {
    if (_nvProd) return Promise.resolve(_nvProd);
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return Promise.resolve(null);
    return fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      _nvProd = {
        type: (p.product_type || '').toLowerCase(),
        tags: (p.tags || []).join(' ').toLowerCase(),
        title: (p.title || '').toLowerCase(),
        sizes: (function () { // collect the size/talla option values
          var opt = (p.options || []).find(function (o) { return /talla|size|tama/i.test(o.name); });
          return opt ? opt.values : [];
        })()
      };
      return _nvProd;
    }).catch(function () { return null; });
  }

  // Category from a combined string (type + tags + title). First match wins.
  function categoryFromString(s) {
    s = s || '';
    if (/pendiente|arete|aretes|collar|colgante|pulsera|brazalete|bufanda|pa[nñ]uelo|fular|bolso|cartera|gafas|gorro|sombrero|diadema|earring|necklace|bracelet|scarf|bag|sunglass|hat/.test(s)) return 'none';
    if (/anillo|sortija|\bring\b/.test(s)) return 'ring';
    if (/cintur[oó]n|correa|\bbelt\b/.test(s)) return 'belt';
    if (/zapat|sandal|bota|bot[ií]n|tac[oó]n|mule|zapatilla|mocas|bailarin|tenis|heel|boot|shoe|d[eé]collet|ballerin|loafer|pump/.test(s)) return 'shoe';
    if (/bikini|ba[nñ]ador|swim|lencer|sujetador|bra\b|push-up|braga/.test(s)) return 'swim';
    if (/pantal|falda|short|jean|legging|trouser|\bpant\b|skirt|culotte|hose|wickelhose/.test(s)) return 'bottom';
    if (/abrigo|chaqueta|blazer|trench|parka|gabardina|coat|jacket|cardigan|chaleco|maglione|su[eé]ter|sweater|knit/.test(s)) return 'outerwear';
    return 'upper';
  }

  // Legacy H1-based detection (fallback only).
  function nvCategoryFromH1() {
    var h1 = document.querySelector('[data-template="product"] h1, main[data-template^="product"] h1');
    var t = (h1 ? h1.textContent : '').toLowerCase();
    if (/anillo|sortija/.test(t)) return 'ring';
    if (/cintur|correa/.test(t)) return 'belt';
    if (/zapat|sandal|bota|bot[ií]n|tac[óo]n|mule|zapatilla|deportiv|mocas|alparg|stiletto|plataforma|chancla|slingback|bailarina/.test(t)) return 'shoe';
    if (/collar|gargantilla|pendiente|arete|pulsera|brazalete|bolso|bolsa|cartera|clutch|bufanda|pa[ñn]uelo|fular|gafas|gorro|sombrero|diadema|broche|llavero|colgante|joyer/.test(t)) return 'none';
    if (/pantal|falda|short|jean|legging|bermuda|culotte|palazzo|vaquero/.test(t)) return 'bottom';
    if (/abrigo|chaqueta|blazer|gabardina|trench|parka|cazadora|chaquet[oó]n|americana/.test(t)) return 'outerwear';
    return 'upper';
  }

  // Async category resolver: uses product info when available, H1 otherwise.
  function nvCategory() {
    return nvProductInfo().then(function (info) {
      if (!info) return nvCategoryFromH1();
      return categoryFromString(info.type + ' ' + info.tags + ' ' + info.title);
    }).catch(function () { return nvCategoryFromH1(); });
  }

  var CAT_LABEL = {
    upper: 'Prenda', bottom: 'Inferior', outerwear: 'Abrigo',
    shoe: 'Calzado', ring: 'Anillo', belt: 'Cinturón', swim: 'Baño'
  };
  var APPAREL = { upper: true, bottom: true, outerwear: true, swim: true };

  var SG_POLICY = '<div class="nv-sg-policy"><span>✓ Devoluciones gratuitas 30 días</span><span>✓ Cambios sin coste</span><span>✓ Atención exclusiva por email</span></div>';
  var SG = {
    upper: { fit: true, sub: 'Equivalencias estándar EU para prendas NOVALISE. Si dudas entre dos tallas, pide la mayor — las devoluciones son gratuitas 30 días.',
      table: '<table class="nv-sg-table"><thead><tr><th>Talla</th><th>EU</th><th>Pecho (cm)</th><th>Cintura (cm)</th><th>Cadera (cm)</th></tr></thead><tbody>' +
        '<tr><td>XS</td><td>34</td><td>80–84</td><td>60–64</td><td>86–90</td></tr><tr><td>S</td><td>36</td><td>84–88</td><td>64–68</td><td>90–94</td></tr>' +
        '<tr><td>M</td><td>38</td><td>88–92</td><td>68–72</td><td>94–98</td></tr><tr><td>L</td><td>40–42</td><td>92–98</td><td>74–80</td><td>100–106</td></tr>' +
        '<tr><td>XL</td><td>44</td><td>100–106</td><td>82–88</td><td>108–114</td></tr><tr><td>XXL</td><td>46</td><td>108–114</td><td>90–96</td><td>116–122</td></tr></tbody></table>',
      howto: '<div class="nv-sg-howto"><h3>Cómo medirte</h3><ul><li><strong>Pecho:</strong> rodea la parte más prominente del busto, cinta horizontal.</li><li><strong>Cintura:</strong> parte más estrecha del torso, sobre el ombligo.</li><li><strong>Cadera:</strong> parte más ancha de caderas y glúteos, pies juntos.</li></ul></div>' },
    bottom: { fit: true, sub: 'Equivalencias estándar EU. Si dudas entre dos tallas, pide la mayor — devoluciones gratuitas 30 días.',
      table: '<table class="nv-sg-table"><thead><tr><th>Talla</th><th>EU</th><th>Cintura (cm)</th><th>Cadera (cm)</th><th>Entrepierna (cm)</th></tr></thead><tbody>' +
        '<tr><td>XS</td><td>34</td><td>60–64</td><td>86–90</td><td>78</td></tr><tr><td>S</td><td>36</td><td>64–68</td><td>90–94</td><td>79</td></tr>' +
        '<tr><td>M</td><td>38</td><td>68–72</td><td>94–98</td><td>80</td></tr><tr><td>L</td><td>40–42</td><td>74–80</td><td>100–106</td><td>81</td></tr>' +
        '<tr><td>XL</td><td>44</td><td>82–88</td><td>108–114</td><td>82</td></tr><tr><td>XXL</td><td>46</td><td>90–96</td><td>116–122</td><td>82</td></tr></tbody></table>',
      howto: '<div class="nv-sg-howto"><h3>Cómo medirte</h3><ul><li><strong>Cintura:</strong> donde sueles llevar la prenda (natural para tiro alto).</li><li><strong>Cadera:</strong> parte más ancha de glúteos y caderas.</li><li><strong>Entrepierna:</strong> largo interior de pierna, de entrepierna al bajo.</li></ul></div>' },
    outerwear: { fit: true, sub: 'Equivalencias estándar EU para abrigos y chaquetas (incluye holgura para llevar prenda debajo).',
      table: '<table class="nv-sg-table"><thead><tr><th>Talla</th><th>EU</th><th>Pecho (cm)</th><th>Cintura (cm)</th><th>Manga (cm)</th></tr></thead><tbody>' +
        '<tr><td>XS</td><td>34</td><td>82–86</td><td>62–66</td><td>60</td></tr><tr><td>S</td><td>36</td><td>86–90</td><td>66–70</td><td>61</td></tr>' +
        '<tr><td>M</td><td>38</td><td>90–94</td><td>70–74</td><td>62</td></tr><tr><td>L</td><td>40–42</td><td>96–102</td><td>76–82</td><td>63</td></tr>' +
        '<tr><td>XL</td><td>44</td><td>104–110</td><td>84–90</td><td>64</td></tr><tr><td>XXL</td><td>46</td><td>112–118</td><td>92–98</td><td>65</td></tr></tbody></table>',
      howto: '<div class="nv-sg-howto"><h3>Cómo medirte</h3><ul><li><strong>Pecho:</strong> parte más ancha, 1–2 cm extra si llevas jersey debajo.</li><li><strong>Cintura:</strong> parte más estrecha del torso.</li><li><strong>Manga:</strong> del centro de la nuca al hombro, codo y muñeca (brazo algo flexionado).</li></ul></div>' },
    swim: { fit: true, sub: 'Equivalencias estándar EU para baño y lencería. Tejido elástico: si dudas entre dos tallas y prefieres más sujeción, elige la menor.',
      table: '<table class="nv-sg-table"><thead><tr><th>Talla</th><th>EU</th><th>Pecho (cm)</th><th>Bajo pecho (cm)</th><th>Cadera (cm)</th></tr></thead><tbody>' +
        '<tr><td>XS</td><td>34</td><td>80–84</td><td>63–67</td><td>86–90</td></tr><tr><td>S</td><td>36</td><td>84–88</td><td>67–71</td><td>90–94</td></tr>' +
        '<tr><td>M</td><td>38</td><td>88–92</td><td>71–75</td><td>94–98</td></tr><tr><td>L</td><td>40–42</td><td>92–98</td><td>75–81</td><td>100–106</td></tr>' +
        '<tr><td>XL</td><td>44</td><td>100–106</td><td>83–89</td><td>108–114</td></tr></tbody></table>',
      howto: '<div class="nv-sg-howto"><h3>Cómo medirte</h3><ul><li><strong>Pecho:</strong> rodea la parte más prominente del busto, cinta horizontal.</li><li><strong>Bajo pecho:</strong> justo debajo del busto, cinta ceñida.</li><li><strong>Cadera:</strong> parte más ancha de caderas y glúteos.</li></ul></div>' },
    shoe: { fit: false, sub: 'El dato decisivo es la longitud de tu pie en cm. Si quedas entre dos tallas, elige la mayor.',
      table: '<table class="nv-sg-table"><thead><tr><th>EU</th><th>US</th><th>UK</th><th>Pie (cm)</th></tr></thead><tbody>' +
        '<tr><td>35</td><td>5</td><td>2.5</td><td>22.0</td></tr><tr><td>36</td><td>6</td><td>3.5</td><td>22.5</td></tr><tr><td>37</td><td>6.5</td><td>4</td><td>23.5</td></tr>' +
        '<tr><td>38</td><td>7.5</td><td>5</td><td>24.0</td></tr><tr><td>39</td><td>8</td><td>6</td><td>25.0</td></tr><tr><td>40</td><td>9</td><td>6.5</td><td>25.5</td></tr>' +
        '<tr><td>41</td><td>9.5</td><td>7.5</td><td>26.5</td></tr><tr><td>42</td><td>10.5</td><td>8</td><td>27.0</td></tr></tbody></table>',
      howto: '<div class="nv-sg-howto"><h3>Cómo medir tu pie</h3><ul><li>De pie sobre un papel, talón pegado a la pared.</li><li>Marca la punta del dedo más largo y mide en cm desde la pared.</li><li>Mídete por la tarde (el pie se hincha); mide ambos pies y usa el mayor.</li></ul></div>' },
    ring: { fit: false, sub: 'En el sistema europeo la talla = circunferencia interior del dedo en mm.',
      table: '<table class="nv-sg-table"><thead><tr><th>Talla EU</th><th>Diámetro (mm)</th><th>Circunf. (mm)</th></tr></thead><tbody>' +
        '<tr><td>49</td><td>15.7</td><td>49</td></tr><tr><td>51</td><td>16.1</td><td>51</td></tr><tr><td>52</td><td>16.6</td><td>52</td></tr><tr><td>53</td><td>17.0</td><td>53</td></tr>' +
        '<tr><td>54</td><td>17.3</td><td>54</td></tr><tr><td>55</td><td>17.5</td><td>55</td></tr><tr><td>56</td><td>17.8</td><td>56</td></tr><tr><td>57</td><td>18.2</td><td>57</td></tr>' +
        '<tr><td>58</td><td>18.6</td><td>58</td></tr><tr><td>60</td><td>19.1</td><td>60</td></tr></tbody></table>',
      howto: '<div class="nv-sg-howto"><h3>Cómo medir tu talla</h3><ul><li><strong>Cuerda/papel:</strong> rodea la base del dedo, marca donde cierra y mide los mm. Ese número es tu talla EU.</li><li><strong>Anillo existente:</strong> mide su diámetro interior en mm y búscalo en la tabla.</li><li>Mídete por la tarde; entre dos tallas, elige la mayor.</li></ul></div>' },
    belt: { fit: false, sub: 'Talla según el contorno de tu cintura. Si caes en el límite superior, elige la mayor.',
      table: '<table class="nv-sg-table"><thead><tr><th>Talla</th><th>Contorno cintura (cm)</th></tr></thead><tbody>' +
        '<tr><td>S</td><td>71–80</td></tr><tr><td>M</td><td>81–90</td></tr><tr><td>L</td><td>91–100</td></tr><tr><td>XL</td><td>101–110</td></tr></tbody></table>',
      howto: '<div class="nv-sg-howto"><h3>Cómo medirte</h3><ul><li>Rodea tu cintura natural con una cinta métrica (donde se forma el pliegue al inclinarte de lado).</li></ul></div>' }
  };

  // Normalize a size label for matching: trim, uppercase, 2XL -> XXL, 3XL -> XXXL.
  function nvNormSize(s) {
    s = String(s == null ? '' : s).trim().toUpperCase();
    var m = s.match(/^([2-9])\s*XL$/);
    if (m) return Array(parseInt(m[1], 10) + 1).join('X') + 'L';
    return s;
  }

  // Filter the <tbody> rows of a size table down to the product's real sizes.
  // table: HTML string. cat: category. sizes: array of product option values.
  function nvFilterTable(table, cat, sizes) {
    if (!sizes || !sizes.length) return table;
    var bodyMatch = table.match(/<tbody>([\s\S]*?)<\/tbody>/);
    if (!bodyMatch) return table;
    var rows = bodyMatch[1].match(/<tr>[\s\S]*?<\/tr>/g) || [];
    if (rows.length < 2) return table;

    var wanted = {};
    sizes.forEach(function (v) { wanted[nvNormSize(v)] = true; });

    var apparel = !!APPAREL[cat]; // bust/waist/hip style rows labelled by letter size
    var kept;

    if (apparel) {
      kept = rows.filter(function (r) {
        var cell = r.match(/<td>([^<]*)<\/td>/);
        var label = cell ? nvNormSize(cell[1]) : '';
        return wanted[label];
      });
    } else if (cat === 'shoe') {
      // Only filter when the product sizes are numeric EU values.
      var numeric = sizes.filter(function (v) { return /^\d{2}(?:[.,]\d)?$/.test(String(v).trim()); });
      if (!numeric.length) return table;
      var wantNum = {};
      numeric.forEach(function (v) { wantNum[String(v).trim().replace(',', '.').replace(/\.0$/, '')] = true; });
      kept = rows.filter(function (r) {
        var cell = r.match(/<td>([^<]*)<\/td>/);
        var label = cell ? cell[1].trim().replace(',', '.').replace(/\.0$/, '') : '';
        return wantNum[label];
      });
    } else {
      return table; // ring / belt: leave full table
    }

    if (kept.length < 2) return table; // safety: too few rows, show all
    return table.replace(/<tbody>[\s\S]*?<\/tbody>/, '<tbody>' + kept.join('') + '</tbody>');
  }

  function sizeModalHTML(cat, sizes) {
    var g = SG[cat] || SG.upper;
    var label = CAT_LABEL[cat] || '';
    var titleTxt = 'Guía de tallas' + (label ? ' · ' + label : '');
    var table = nvFilterTable(g.table, cat, sizes);
    return '<div class="nv-sg-modal" id="nv-sg-modal" role="dialog" aria-modal="true" aria-labelledby="nv-sg-title" hidden>' +
      '<div class="nv-sg-modal__backdrop" data-nv-sg-close></div>' +
      '<div class="nv-sg-modal__panel">' +
        '<button type="button" class="nv-sg-modal__close" data-nv-sg-close aria-label="Cerrar">×</button>' +
        '<div class="nv-sg-modal__eyebrow">Atelier NOVALISE</div>' +
        '<h2 class="nv-sg-modal__title" id="nv-sg-title">' + titleTxt + '</h2>' +
        '<p class="nv-sg-modal__sub">' + g.sub + '</p>' + table + g.howto + SG_POLICY +
      '</div>' +
    '</div>';
  }
  function isProductPage() {
    const m = document.querySelector('main[data-template]');
    if (m && /product/.test(m.getAttribute('data-template') || '')) return true;
    if (document.body.classList.contains('template-product')) return true;
    if (window.location.pathname.indexOf('/products/') === 0) return true;
    return false;
  }
  function openSizeGuide(e) {
    if (e) e.preventDefault();
    let modal = document.getElementById('nv-sg-modal');
    if (modal) {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      return;
    }
    nvCategory().then(function (cat) {
      var sizes = (_nvProd && _nvProd.sizes) || [];
      const wrap = document.createElement('div');
      wrap.innerHTML = sizeModalHTML(cat, sizes);
      document.body.appendChild(wrap.firstElementChild);
      modal = document.getElementById('nv-sg-modal');
      modal.querySelectorAll('[data-nv-sg-close]').forEach(el => el.addEventListener('click', closeSizeGuide));
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') closeSizeGuide();
      });
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeSizeGuide() {
    const modal = document.getElementById('nv-sg-modal');
    if (modal) modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
  function injectSizeGuideLink() {
    if (!isProductPage()) return;
    const picker = document.querySelector('variant-picker, [class*="variant-picker"]');
    if (!picker) return;
    if (document.querySelector('.nv-sg-trigger')) return;
    nvCategory().then(function (cat) {
      if (cat === 'none') return;
      if (document.querySelector('.nv-sg-trigger')) return;
      var showFit = !!APPAREL[cat] && SG[cat] && SG[cat].fit;
      var fitHTML = showFit ? '<div class="nv-sg-fit">Modelo: 1,78 m · Lleva talla S · Corte true to size</div>' : '';
      const trigger = document.createElement('div');
      trigger.className = 'nv-sg-trigger-wrap';
      trigger.innerHTML = (
        fitHTML +
        '<button type="button" class="nv-sg-trigger">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M3 12h18M7 8l-4 4 4 4M17 8l4 4-4 4"/></svg>' +
          '<span>Guía de tallas</span>' +
        '</button>'
      );
      picker.parentNode.insertBefore(trigger, picker.nextSibling);
      trigger.querySelector('.nv-sg-trigger').addEventListener('click', openSizeGuide);
    });
  }

  // ========================================
  // PUBLIC API
  // ========================================
  window.NVWishlist = {
    get: read, has: has, toggle: toggle,
    count: function () { return read().length; },
    clear: function () { write([]); updateCounts(); },
    inject: injectIntoCards, render: renderWishlistGrid
  };
  window.NVSizeGuide = { open: openSizeGuide, close: closeSizeGuide };

  // ========================================
  // BOOT
  // ========================================
  function boot() {
    injectIntoCards();
    updateCounts();
    renderWishlistGrid();
    injectEmptyCart();
    injectSizeGuideLink();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  let debounce;
  const mo = new MutationObserver(function (muts) {
    // Ignore mutations we caused ourselves (empty-cart inject/remove), so observing
    // our own insertion never re-triggers a fresh injection loop.
    if (nvInjectingEmpty) return;
    let needed = false;
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) {
        // Skip mutations whose only added nodes are our own block.
        let onlyOurs = true;
        for (const n of m.addedNodes) {
          if (!(n.nodeType === 1 && (n.classList && n.classList.contains('nv-cart-empty-editorial') || (n.getAttribute && n.getAttribute('data-nv-empty'))))) {
            onlyOurs = false; break;
          }
        }
        if (!onlyOurs) { needed = true; break; }
      }
    }
    if (needed) {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        injectIntoCards();
        injectEmptyCart();
        injectSizeGuideLink();
      }, 150);
    }
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  document.addEventListener('cart:update', function () {
    setTimeout(injectEmptyCart, 100);
  });
})();
